import { render } from "./RiCheng.vue?vue&type=template&id=c15b8172"
import script from "./RiCheng.vue?vue&type=script&lang=js"
export * from "./RiCheng.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__